<script>
import Header from '@components/header'

export default {
  components: { Header },
  props:{
    use_language: {
      default:false
    },
    selected_language: {
      default: 'us'
    },
    company: {
      default:{ }
    },
  },
  methods:{
		changeLang(lang){
			this.$emit('changeLang', lang)
		}
	},
}
</script>

<template>
  <div>
    <Header :company="company" :use_language="use_language" :selected_language="selected_language" @changeLang="changeLang"/>
    <div class="content-page ml-0 p-0">
      <div class="content">
        <div class="container-fluid p-0">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

